import { Type } from "class-transformer";


export class DhcAstItem {
    astType: string;
    text: string;
    from = 0;
    to = 0;
    @Type(() => DhcAstItem)
    children: DhcAstItem[];
}
